import store from 'src/store';

import integration from 'src/lib/api/integration';
import pd from 'src/lib/api/pagerduty';
import { textifyError } from 'src/lib/error';

import {
  finishLoadingById,
  finishLoadingByService,
  finishLoadingBySidebar,
  noLinkedIncident,
  reset,
  startLoadingById,
  startLoadingByService,
  startLoadingBySidebar,
  waitingForInitialization,
} from './actions';

let consumersCount = 0;
let isLoggedIn = undefined;
let apiKeyAvailable = undefined;
let sidebarInfoAvailable = undefined;
let jiraContext = undefined;

let searchByIdStatus = { empty: true };
let searchBySidebarInfoStatus = { empty: true };
let searchByServiceStatus = { empty: true };

async function doSearchById() {
  store.dispatch(startLoadingById(jiraContext.issuePdProps.incidentId));

  const task = Math.random();
  searchByIdStatus = { loading: true, task };

  const results = await pd
    .getIncident(jiraContext.issuePdProps.incidentId, { include: ['external_references'] })
    .then(incident => ({ incident }))
    .catch(error => ({ error: textifyError(error) }));

  if (results.error === 'Incident Not Found') {
    store.dispatch(finishLoadingById(jiraContext.issuePdProps.incidentId, null, null));
    return;
  }

  if (task !== searchByIdStatus.task) return;
  searchByIdStatus = results;
  store.dispatch(finishLoadingById(jiraContext.issuePdProps.incidentId, results.incident, results.error));
}

async function doSearchBySidebarInfo() {
  store.dispatch(startLoadingBySidebar());

  const task = Math.random();
  searchBySidebarInfoStatus = { loading: true, task };

  const results = await pd
    .getLegacySidebarInfo(jiraContext.issueKey, jiraContext.issueTypeId)
    .then(({ incident }) => ({ incident }))
    .catch(error => {
      if (error?.message?.includes('Can not find linked PagerDuty account')) {
        return { incident: undefined };
      } else return { error: textifyError(error) };
    });

  if (task !== searchBySidebarInfoStatus.task) return;
  searchBySidebarInfoStatus = results;
  store.dispatch(finishLoadingBySidebar(results.incident, results.error));
}

async function doSearchByService() {
  store.dispatch(startLoadingByService());

  const task = Math.random();
  searchByServiceStatus = { loading: true, task };

  const results = await integration
    .getIncidentIssueMappingByIssueKey(jiraContext.issueKey)
    .then(({ incident }) => ({ incident }))
    .catch(error => ({ error }));

  if (task !== searchByServiceStatus.task) return;
  searchByServiceStatus = results;
  store.dispatch(finishLoadingByService(results.incident, results.error));
}

function searchAll() {
  const { linkedIncident: { incident, loading } } = store.getState();

  const initializationComplete = [
    isLoggedIn,
    apiKeyAvailable,
    sidebarInfoAvailable,
    jiraContext,
  ].every(x => x !== undefined);

  if (consumersCount > 0 && !loading && !initializationComplete) {
    store.dispatch(waitingForInitialization());
  }

  if (!initializationComplete) return;
  if (consumersCount === 0 || incident) return;

  const apiAccessAvailable = apiKeyAvailable || isLoggedIn;
  const incidentId = jiraContext.issuePdProps && jiraContext.issuePdProps.incidentId;
  const issueKey = jiraContext && jiraContext.issueKey;

  const shouldStartSearchById = searchByIdStatus.empty && apiAccessAvailable && incidentId;
  const shouldStartSearchBySidebarInfo = searchBySidebarInfoStatus.empty && sidebarInfoAvailable && issueKey;

  doSearchByService();
  if (shouldStartSearchById) doSearchById();
  if (shouldStartSearchBySidebarInfo) doSearchBySidebarInfo();

  if (!loading && !(shouldStartSearchById || shouldStartSearchBySidebarInfo)) {
    console.log('Can not find a way to load incident');
    store.dispatch(noLinkedIncident());
  }
}

export const addConsumer = () => {
  consumersCount++;
  searchAll();
};

export const removeConsumer = () => {
  consumersCount--;
};

export const loggedIn = (is) => {
  isLoggedIn = is;

  const { linkedIncident: { loading, incident, error } } = store.getState();
  if (loading || incident || error) {
    store.dispatch(reset());
  }

  searchByIdStatus = { empty: true };
  searchBySidebarInfoStatus = { empty: true };
  searchAll();
};

export const setApiKeyAvailable = (is) => {
  apiKeyAvailable = is;
  searchAll();
};

export const setSidebarInfoAvailable = (is) => {
  sidebarInfoAvailable = is;
  searchAll();
};

export const setJiraContext = (context) => {
  jiraContext = context;
  searchAll();
};
